export default __webpack_public_path__ + "static/media/September_07.0dd3df25.png";